function InitializeVoterInformation() {
    $('#all-registered-voters input:checkbox').click(function () {
        if ($(this).is(':checked')) {
            $('.voter-information-selections input:checkbox').prop('checked', true);
        } else {
            $('.voter-information-selections input:checkbox').prop('checked', false);
        }
    });

    $('.voter-information-selections input:checkbox').click(function () {
        CheckAllRegisteredVoters();
    });

    CheckAllRegisteredVoters();
}

function CheckAllRegisteredVoters() {
    var voterSelections = $('.voter-information-selections input:checkbox');
    var voterSelected = $('.voter-information-selections input:checkbox:checked');
    if (voterSelections.length != voterSelected.length) {
        $('#all-registered-voters input:checkbox').prop('checked', false);
    } else {
        $('#all-registered-voters input:checkbox').prop('checked', true);
    }
} 




